// LOCAL-date helpers. new Date().toISOString() is UTC: in Alaska (UTC-8/-9)
// every evening is already "tomorrow" in UTC, which stamped signature dates
// a day ahead (Jill, expense report, 2026-07-08). Anything user-facing that
// means "today where the pilot is standing" must use these.
export function localToday() {
  return localDatePlus(0);
}

// Today's calendar date in Alaska (America/Anchorage), whatever the device
// clock says. The program clock is judged against this, the same day the
// database uses (set_training_clock), so a traveling user sees the same
// days left as everyone else.
const akDay = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Anchorage", year: "numeric", month: "2-digit", day: "2-digit" });
export function alaskaToday(now = new Date()) {
  const parts = Object.fromEntries(akDay.formatToParts(now).map((x) => [x.type, x.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function localDatePlus(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// ---------------------------------------------------------------------------
// Display formats (design review 2026-07-23): one date grammar on screen.
// Data stays ISO; anything a person READS goes through these.
//   fmtDay("2026-08-03")            -> "Aug 3"        (year shown only if not this year)
//   fmtDayRange("2026-08-03", ...)  -> "Aug 3 to Aug 7"  (the word "to", never an arrow)
//   fmtStamp(timestamp)             -> "Jul 23, 8:43 AM"
// Date-only strings get a noon time so Alaska evenings don't shift a day.

function asDate(v) {
  // new Date(null) is NOT invalid — JS coerces null to epoch 0, which renders
  // as "Dec 31, 1969" in Alaska. A trip with no committed segment dates fed
  // exactly that into the workspace row (Biagi's STAR PRINCESS + Jill's ROYAL
  // PRINCESS, 2026-07-25). No value means no date, never 1969.
  if (v == null || v === "" || v === 0) return null;
  if (v instanceof Date) return v;
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) return new Date(v + "T12:00:00");
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

export function fmtDay(v) {
  const d = asDate(v);
  if (!d) return "";
  const opts = { month: "short", day: "numeric" };
  if (d.getFullYear() !== new Date().getFullYear()) opts.year = "numeric";
  return d.toLocaleDateString("en-US", opts);
}

export function fmtDayRange(a, b) {
  const from = fmtDay(a), to = fmtDay(b);
  if (!from) return to;
  if (!to || from === to) return from;
  return `${from} to ${to}`;
}

export function fmtStamp(v) {
  const d = asDate(v);
  if (!d) return "";
  return `${fmtDay(d)}, ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
}
